import store from "./store";

export const flatten = (array) => {
  for (var i = 0; i < array.length; i++) {
    if (array[i].Type === "Category" && array[i].Items.length && array[i].Items[0].Type === "Category") {
      for (var j = 0; j < array[i].Items.length; j++) {
        array[i].Items[j].Name = array[i].Name + " / " + array[i].Items[j].Name;
        array.splice(i, 0, array[i].Items[j]);
        i++;
      }
      array.splice(i, 1);
      i--;
    }
  }
};

export const flattenCategory = (category) => {
  if (category.Type === "Category" && category.Items.length && category.Items[0].Type === "Category") {
    category.Items[0].Name = category.Name + " / " + category.Items[0].Name;
    return category.Items[0];
  } else {
    return category;
  }
};

export const getResource = ({ dispatch }, ResourceKey) => {
  for (var i = 0; i < store._vm.resources.length; i++) {
    if (store._vm.resources[i].ResourceKey === ResourceKey) {
      return store._vm.resources[i].ResourceValue;
    }
  }
  return "Missing translation";
};

export const fillCategories = (categories, filtersCategories, filtersItems) => {
  for (var i = 0; i < categories.length; i++) {
    categories[i].checked = false;
    filtersCategories.push(categories[i]);

    fillItems(categories[i].Items, filtersItems);
  }
};

export const fillItems = (items, filtersItems) => {
  for (var i = 0; i < items.length; i++) {
    items[i].checked = false;
    filtersItems.push(items[i]);
  }
};



// WEBPACK FOOTER //
// ./src/vuex/helpers.js